import IBean from './IBean'
import { isString, isArray } from 'util'

export default class LayerBean extends IBean {
    /**
     * 图层组bean
     * @param {mapboxgl.Map} map
     * @param {String|Array.<String>} layerNames
     */
    constructor(map, layerNames) {
        super()
        this.map = map
        this.layers = []
        if (isString(layerNames)) {
            this.layers = [layerNames]
        }
        if (isArray(layerNames)) {
            this.layers = [...layerNames]
        }
    }
}
